import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Response interceptor: handle 401 with refresh
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const url = error.config?.url || "";
    if (url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/google") || url.includes("/auth/refresh")) {
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        if (data.email) {
          return api(error.config);
        }
      } catch (refreshErr) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Token refresh failed:", refreshErr?.response?.status || refreshErr?.message);
        }
      }
      const path = window.location.pathname;
      if (!path.includes("/login") && !path.includes("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Errore di connessione al server. Verifica la tua connessione e riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
